/* eslint-disable no-param-reassign */
import markdown from './markdown';

/* Adds support for mentions to our Markdown renderer. Keep in mind that
 * in the server we replace slugs with names while here that doesn't happen */

const CHAR = {
  AT: 64,
  DOLLAR: 36,
};

// Based on https://git.io/vQ6ef
function isWhiteSpace(code) {
  if (code >= 0x2000 && code <= 0x200A) return true;
  switch (code) {
    case 0x09: // \t
    case 0x0A: // \n
    case 0x0B: // \v
    case 0x0C: // \f
    case 0x0D: // \r
    case 0x20:
    case 0xA0:
    case 0x1680:
    case 0x202F:
    case 0x205F:
    case 0x3000:
      return true;
    default:
      return false;
  }
}

// Please update both this method and the regex below if the
// supported slugs change in the future
function isMentionSymbol(code) {
  switch (code) {
    case CHAR.AT:
    case CHAR.DOLLAR:
      return true;
    default:
      return false;
  }
}

const mentionPattern = /^(\w[\da-zA-Z-]{0,59})\b/i;

// MarkdownIt extension for mentions, based on https://git.io/vQoo5
function applyMentions(state, silent) {
  const pos = state.pos;

  if (silent || !isMentionSymbol(state.src.charCodeAt(pos))) {
    return false;
  }

  if (pos > 0) {
    const prev = state.src.charCodeAt(pos - 1);
    if (!isWhiteSpace(prev)) return false;
  }

  // Skip if in a link
  if (state.tokens) {
    const last = state.tokens[state.tokens.length - 1];
    if (last) {
      if (last.type === 'link_open') {
        return false;
      }
      if (last.type === 'html_inline' && last.content.substr(0, 2) === '<a') {
        return false;
      }
    }
  }

  const symbol = state.src.substr(pos, 1);
  const mention = state.src.substr(pos + 1);
  const matches = mention.match(mentionPattern);

  if (!matches) return false;

  const slug = matches[1];
  const tag = 'a';
  const className = 'Mention';
  const href = state.src.charCodeAt(pos) === CHAR.AT ? `/users/${slug}` : `/companies/${slug}`;

  let token = state.push('mention_open', tag, 1);
  token.attrs = [['class', className]];

  if (href) {
    token.attrs.push(['href', href]);
  }

  token = state.push('text', '', 0);
  token.content = symbol + slug;

  state.push('mention_close', tag, -1);

  state.pos = pos + slug.length + 1;

  return true;
}

markdown.inline.ruler.push('mentions',
  (state, silent) => applyMentions(state, silent)
);

export default markdown;
